import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';

const useBrowserLang = () => {
  if (typeof navigator === 'undefined') return;

  // eslint-disable-next-line
  const [ cookies ] = useCookies(['selected_lang']);

  let lang = cookies?.selected_lang || navigator.language || navigator.browserLanguage;

  if (lang.indexOf('-') > -1) {
    lang = lang.split('-')[0];
  }

  return lang;
};

export default useBrowserLang;